/**
 * scripts.js
 *
 * This is where you should write your custom javascript code
 */

if ($('.scroll-reveal').length > 0) {
    sr.reveal('.scroll-reveal', {
        // 'bottom', 'left', 'top', 'right'
        origin: 'bottom',

        // Can be any valid CSS distance, e.g. '5rem', '10%', '20vw', etc.
        distance: '20px',

        // Time in milliseconds.
        duration: 500,
        delay: 0,

        // Starting angles in degrees, will transition from these values to 0 in all axes.
        rotate: { x: 0, y: 0, z: 0 },

        // Starting opacity value, before transitioning to the computed opacity.
        opacity: 0,

        // Starting scale value, will transition from this value to 1
        scale: 0.9,

        // Accepts any valid CSS easing, e.g. 'ease', 'ease-in-out', 'linear', etc.
        easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)',

        // `<html>` is the default reveal container. You can pass either:
        // DOM Node, e.g. document.querySelector('.fooContainer')
        // Selector, e.g. '.fooContainer'
        container: window.document.documentElement,

        // true/false to control reveal animations on mobile.
        mobile: false,

        // true:  reveals occur every time elements become visible
        // false: reveals occur once as elements become visible
        reset: false,

        // 'always' — delay for all reveal animations
        // 'once'   — delay only the first time reveals occur
        // 'onload' - delay only for animations triggered by first load
        useDelay: 'always',

        // Change when an element is considered in the viewport. The default value
        // of 0.20 means 20% of an element must be visible for its reveal to occur.
        viewFactor: 0.2,
    });
}


$(function () {
    $('#gallery').photoSwipe('img', {
        shareEl: false,
        captionEl: false,
        fullscreenEl: false
    });
});


if (document.querySelector('.masonry-grid')) {
    var grid = document.querySelector('.masonry-grid');
    var msnry = new Masonry(grid, {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true
    });
    imagesLoaded(grid).on('progress', function () {
        msnry.layout();
    });
}


// Jumbotron Slider
$('.jumbotron-slider').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    arrows: false,
    swipe: false,
    touchMove: false,
    draggable: false,
    dots: false,
    fade: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false
});

// Navbar Show/Hide
var slider = document.querySelector('.jumbotron-slider');
var hero = document.querySelector('.jumbotron');

if (slider) {
    var offset = slider.offsetHeight;
} else if (hero) {
    var offset = hero.offsetHeight;
} else {
    offset = 0;
}

var navbar = document.querySelector('.navbar');
var headroom = new Headroom(navbar, {
    "offset": offset,
    "tolerance": {
        "down": 10,
        "up": 15
    },
    "classes": {
        "initial": "animated",
        "pinned": "slideInDown",
        "unpinned": "slideOutUp",
        "top": "navbar-top",
        "notTop": "navbar-not-top",
        "bottom": "navbar-bottom",
        "notBottom": "navbar-not-bottom"
    }
});
headroom.init();

if (slider) {
    var i = 0;
    var video = document.getElementById('jumbotron-video');
    var chars = $('.character');
    var callout = $('.jumbotron-slider .animated');

    video.onloadeddata = function() {
        var fadeInit = setInterval(fadeCharacters, 40);

        function fadeCharacters() {
            var char = chars[i++];
            $(char).css({
                opacity: 1
            });
            if (i === chars.length) {
                callout.delay(250).queue(function() {
                    $(this).addClass('fadeIn').dequeue();
                });
                fadeStop();
            }
        }

        function fadeStop() {
            clearInterval(fadeInit);
        }
    };

    // let vh = window.innerHeight * 0.01;
    // document.documentElement.style.setProperty('--vh', `${vh}px`);

    // window.addEventListener('resize', () => {
    //     let vh = window.innerHeight * 0.01;
    //     document.documentElement.style.setProperty('--vh', `${vh}px`);
    // });
}

// Google Analytics Send Event

var pageTitle = document.title.split('|')[1].trim();

$('[data-ga-event="hero-phone"').click(function() {
    var action, category, label;

    switch(pageTitle) {
        case 'Home':
            action = 'PhoneClick';
            category = 'HomePage';
            label = 'Home';
            break;
    }

    gtag('event', action, {
      'event_category': category,
      'event_label': label,
      'value': 1,
    });

});

$('[data-ga-event="form-phone"').click(function() {
    var action, category, label;

    switch(pageTitle) {
        case 'Car Accidents':
            action = 'PhoneClick';
            category = 'PersonalInjury';
            label = 'CarAcc';
            break;
        case 'Motorcycle Accidents':
            action = 'PhoneClick';
            category = 'PersonalInjury';
            label = 'MotoAcc';
            break;
        case 'Brain & Spinal (Catastrophic) Injuries':
            action = 'PhoneClick';
            category = 'PersonalInjury';
            label = 'BrainSpine';
            break;
        case 'Slip & Fall':
            action = 'PhoneClick';
            category = 'PersonalInjury';
            label = 'SlipFall';
            break;
        case 'Accident Benefit & Malpractice Claims':
            action = 'PhoneClick';
            category = 'PersonalInjury';
            label = 'Malpractice';
            break;
        case 'Long Term Disability Claims':
            action = 'PhoneClick';
            category = 'PersonalInjury';
            label = 'LTDisab';
            break;
        case 'Children’s Injuries':
            action = 'PhoneClick';
            category = 'PersonalInjury';
            label = 'ChildInj';
            break;
        case 'Major Orthopedic Injuries':
            action = 'PhoneClick';
            category = 'PersonalInjury';
            label = 'Ortho';
            break;
        case 'Amputees':
            action = 'PhoneClick';
            category = 'PersonalInjury';
            label = 'Amputee';
            break;
        case 'Paraplegic / Quadriplegic':
            action = 'PhoneClick';
            category = 'PersonalInjury';
            label = 'ParaQuad';
            break;
        case 'ATV, Snowmobile & Boating Accidents':
            action = 'PhoneClick';
            category = 'PersonalInjury';
            label = 'AtvSnoBoat';
            break;
        case 'Second Opinions':
            action = 'PhoneClick';
            category = 'PersonalInjury';
            label = 'SecondOp';
            break;
    }

    if (action) {
        gtag('event', action, {
          'event_category': category,
          'event_label': label,
          'value': 1
        });
    }
});

// Contact Form
var form = $('#form');

if (form.length > 0) {
    // On grecaptcha init pass token through to value of hidden input
    const grecaptcha_site_key = "6LduLe4UAAAAAAVErdqMQSROlCj29WwhDI9kopL6";

    grecaptcha.ready(function () {
        grecaptcha.execute(grecaptcha_site_key, { action: 'contact' }).then(function (token) {
            var recaptchaResponse = document.getElementById('g-recaptcha-response');
            recaptchaResponse.value = token;
        });
    });

    // Get Page Title
    var pageTitle = document.title.split('|')[1].trim();

    // Notification Close Button
    var dismiss = $('.alert-dismiss');

    dismiss.click(function(e) {
        e.preventDefault();
        $(this).closest('.mail-notification').removeClass('fadeIn').addClass('fadeOut');
    });

    // Contact Form Submit
    form.on('submit', function(e) {
        e.preventDefault();

        grecaptcha.execute(grecaptcha_site_key, { action: 'contact' }).then(function (token) {
            var recaptchaResponse = document.getElementById('g-recaptcha-response');
            recaptchaResponse.value = token;

            var formData = $(form).serialize();
            var name = $('#name').val();
            var message = $('.mail-notification .mail-message');
            var notification = $('.mail-notification');

            $.ajax({
                type: 'POST',
                url: form.attr('action'),
                data: formData + '&page=' + pageTitle
            })

            if (notification.hasClass('d-none')) {
                message.text('Thank you for your message we will get back to you at the earliest possible time.');
                dismiss.find('circle').css('animation', 'countdown 6s linear forwards');
                notification.toggleClass('d-none').addClass('fadeIn');
                notification.delay(6000).queue(function() {
                    $(this).removeClass('fadeIn').addClass('fadeOut').dequeue();
                });
            }

            form.addClass('form-disabled');
            form.find('input[type=submit]').prop('disabled', true);
            form.find('input[type=submit]').val('Message Sent');

            var action, category, label;

            switch(pageTitle) {
                case 'Home':
                    action = 'SendInfo';
                    category = 'HomePage';
                    label = 'Home';
                    break;
                case 'Car Accidents':
                    action = 'SendInfo';
                    category = 'PersonalInjury';
                    label = 'CarAcc';
                    break;
                case 'Motorcycle Accidents':
                    action = 'SendInfo';
                    category = 'PersonalInjury';
                    label = 'MotoAcc';
                    break;
                case 'Brain & Spinal (Catastrophic) Injuries':
                    action = 'SendInfo';
                    category = 'PersonalInjury';
                    label = 'BrainSpine';
                    break;
                case 'Slip & Fall':
                    action = 'SendInfo';
                    category = 'PersonalInjury';
                    label = 'SlipFall';
                    break;
                case 'Accident Benefit & Malpractice Claims':
                    action = 'SendInfo';
                    category = 'PersonalInjury';
                    label = 'Malpractice';
                    break;
                case 'Long Term Disability Claims':
                    action = 'SendInfo';
                    category = 'PersonalInjury';
                    label = 'LTDisab';
                    break;
                case 'Children’s Injuries':
                    action = 'SendInfo';
                    category = 'PersonalInjury';
                    label = 'ChildInj';
                    break;
                case 'Major Orthopedic Injuries':
                    action = 'SendInfo';
                    category = 'PersonalInjury';
                    label = 'Ortho';
                    break;
                case 'Amputees':
                    action = 'SendInfo';
                    category = 'PersonalInjury';
                    label = 'Amputee';
                    break;
                case 'Paraplegic / Quadriplegic':
                    action = 'SendInfo';
                    category = 'PersonalInjury';
                    label = 'ParaQuad';
                    break;
                case 'ATV, Snowmobile & Boating Accidents':
                    action = 'SendInfo';
                    category = 'PersonalInjury';
                    label = 'AtvSnoBoat';
                    break;
                case 'Second Opinions':
                    action = 'SendInfo';
                    category = 'PersonalInjury';
                    label = 'SecondOp';
                    break;
            }

            if (action) {
                gtag('event', action, {
                  'event_category': category,
                  'event_label': label,
                  'value': 1
                });
            }

            // _gaq.push(['_trackEvent', 'Contact Form', 'Submit', pageTitle]);
            // form.find('input, textarea').val('');
        });

    });
}

// Material Contact Form Animation
$('#form').find('.form-control').each(function() {
  var targetItem = $(this).parent();
  if ($(this).val()) {
    $(targetItem).find('label').css({
      'top': '10px',
      'fontSize': '14px'
    });
  }
})
$('#form').find('.form-control').focus(function() {
  $(this).parent('.form-group').addClass('focus');
  $(this).parent().find('label').animate({
    'top': '10px',
    'fontSize': '14px'
  }, 200);
})
$('#form').find('.form-control').blur(function() {
  if ($(this).val().length == 0) {
    $(this).parent('.form-group').removeClass('focus');
    $(this).parent().find('label').animate({
      'top': '30px',
      'fontSize': '14px'
    }, 200);
  }
})

// Phone Number Mask
if (document.getElementById('phone')) {
    document.getElementById('phone').addEventListener('input', function (e) {
      var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    });
}


// WEBPACK FOOTER //
// ./src/js/scripts.js